import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE || 'http://127.0.0.1:5140';

export const api = axios.create({
  baseURL,
  timeout: 60_000,
});

// Token injection — pulled fresh from localStorage so multi-tab works.
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('cp_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Global 401 handler — drop creds, kick to login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cp_token');
      if (location.pathname !== '/login') {
        location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);

// Convenience helpers — all return resp.data.
export const get  = (url, cfg) => api.get(url, cfg).then((r) => r.data);
export const post = (url, body, cfg) => api.post(url, body, cfg).then((r) => r.data);
export const put  = (url, body, cfg) => api.put(url, body, cfg).then((r) => r.data);
export const del  = (url, cfg) => api.delete(url, cfg).then((r) => r.data);
